import { RootState } from "@app/redux/root-reducer";

export const selectDashboardState = (store: RootState) =>
  store.dashboardReducer.dashboard;
